export interface RoryQuote {
  id: number;
  number: number;
  slug: string;
  text: string;
  source: string;
  display_source: string | null;
  tags: string[];
  votes: number;
  spectator: boolean;
  path: string;
}

export const SITE_ORIGIN = "https://www.42courses.com";

export const quoteUrl = (quote: RoryQuote) =>
  `${typeof window !== "undefined" ? window.location.origin : SITE_ORIGIN}${quote.path}`;
